import React from "react";
import { FormattedMessage } from "react-intl";

/**
 * PlanerTitle: () => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Localized title for the planer view
 */
const PlanerTitle = () => (
  <div>
    <h3>
      <FormattedMessage
        id="agenda.planer.title"
        description="Title for tasks view in agenda"
      />
    </h3>
  </div>
);

export default PlanerTitle;



// WEBPACK FOOTER //
// ./src/modules/agenda/planer/PlanerTitle.js